import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase/config";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [clinicaId, setclinicaId] = useState(null);
  const [clinicaData, setClinicaData] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Verificar si es superadmin
        const superAdminRef = doc(db, 'superAdmins', user.uid);
        const superAdminSnap = await getDoc(superAdminRef);
        console.log('superAdmin exists:', superAdminSnap.exists(), 'uid:', user.uid);

        if (superAdminSnap.exists()) {
          setIsSuperAdmin(true);
          setCurrentUser(user);
          setUserRole('superadmin');
          setclinicaId(null);
          setClinicaData(null);
          setLoading(false);
          return;
        }

        // Usuario normal — buscar en colección usuarios con clinicaId
        const userRef = doc(db, 'usuarios', user.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const userData = userSnap.data();
          setUserRole(userData.rol);
          setclinicaId(userData.clinicaId);

          // Cargar datos de la clínica
          const clinicaRef = doc(db, 'clinicas', userData.clinicaId);
          const clinicaSnap = await getDoc(clinicaRef);
          if (clinicaSnap.exists()) {
            setClinicaData(clinicaSnap.data());
          }
        }

        setCurrentUser(user);
      } else {
        setCurrentUser(null);
        setUserRole(null);
        setclinicaId(null);
        setClinicaData(null);
        setIsSuperAdmin(false);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userRole,
    clinicaId,
    clinicaData,
    isSuperAdmin,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}